import { PhoneNumberType } from "@/types/customer/customer.type";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import { PhoneModuleInterface } from "@/interface/phone";

let PhoneNumber = require("awesome-phonenumber");

class PhoneModule implements PhoneModuleInterface {
  number?: string = "";
  is_valid?: boolean = false;
  national?: string = "";
  international?: string = "";
  county_code?: string = "";
  country?: string = "";

  constructor(phone?) {
    this.country = Storage.get(StorageConstants.BUSINESS).country;
    console.log("this", this);
    if (!phone) return;

    const testPhone = PhoneNumber(`+${phone}`);

    if (testPhone?.isValid) {
      this.prepareData(testPhone);
      return;
    }
    this.initData(phone);
  }

  private initData(phone): void {
    const phoneNumber = PhoneNumber(`+${this.county_code}${phone?.number}`);
    this.number = phone?.number ?? phone;
    this.is_valid = phone?.is_valid || phoneNumber.isValid();
    this.county_code = phone?.county_code || PhoneNumber(`+${this.county_code}${phone.number}`).getCountryCode() || "";
    this.country = phone?.country || PhoneNumber(`+${this.county_code}${phone.number}`).getRegionCode() || "";

    if (!!phone.number) {
      this.national = PhoneNumber(`+${this.county_code}${phone.number}`).getNumber("national");
      this.international = PhoneNumber(`+${this.county_code}${phone.number}`).getNumber();
    }
  }

  private prepareData(testPhone): void {
    const json = testPhone.toJSON();
    this.number = json?.number?.national;
    this.is_valid = json?.valid;
    this.country = json?.regionCode;
  }

  getData(): PhoneNumberType {
    return {
      number: this.national,
      is_valid: this.is_valid,
    };
  }

  toJson(): any {
    const international = this.international || "";
    return {
      number: parseInt(international),
      is_valid: this.is_valid,
    };
  }

  /**
   * getInternational
   * @return{string}
   */
  public getInternational(): string {
    let currentPhone: any = this.number;
    currentPhone = currentPhone.toString().replace(`${this.county_code}`, "");

    return (
      PhoneNumber(`+${this.county_code}${currentPhone}`)
        ?.getNumber("international")
        ?.replace("+", "")
        ?.replaceAll(" ", "") || ""
    );
  }

  /**
   * getInternational
   * @return{string}
   */
  public getNational(): string {
    let currentPhone: any = this.number;
    currentPhone = currentPhone.toString().replace(`${this.county_code}`, "");

    return PhoneNumber(`+${this.county_code}${currentPhone}`)?.getNumber("international")?.replaceAll(" ", "") || "";
  }
}

export default PhoneModule;

/***
 *

 console.log("canBeInternationallyDialled", testPhone.canBeInternationallyDialled());
 console.log("getCountryCode", testPhone.getCountryCode());
 console.log("getNumber", testPhone.getNumber());
 console.log("getNumberFrom", testPhone.getNumberFrom());
 console.log("getRegionCode", testPhone.getRegionCode());
 console.log("getType", testPhone.getType());
 console.log("toJSON", testPhone.toJSON());
 console.log("number", testPhone.number);
 console.log("testPhone", testPhone);

 * JSON
 possibility: "is-possible"
 possible: true
 regionCode: "EG"
 type: "mobile"
 valid: true
 number: {
       e164: "+201001234567"
       input: "+201001234567"
       international: "+20 100 123 4567"
       national: "0100 123 4567"
       rfc3966: "tel:+20-100-123-4567"
       significant: "1001234567"
     }

 */
